import { Controller } from "@hotwired/stimulus"

// Sprint 7 (01/06/2026) — Bulk actions reusable Stimulus controller.
//
// Sélection multi-lignes + footer sticky d'actions groupées. Réutilisable
// sur n'importe quel tableau (referrals d'abord, puis supports_b2c plus tard).
//
// Targets attendus :
//   - selectAll: la checkbox header "Tout sélectionner"
//   - row: les checkboxes par ligne (data-id={referral_id})
//   - footer: le footer sticky qui apparaît si 1+ sélectionnés
//   - count: span dans footer affichant le compte
//
// Values :
//   - url: endpoint PATCH bulk (ex: /referrals/bulk_update)
//   - actionType: ex "mark_distributed"
export default class extends Controller {
  static targets = ["selectAll", "row", "footer", "count"]
  static values = { url: String, actionType: String }

  connect() {
    this.updateFooter()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.rowTargets.forEach(cb => { cb.checked = checked })
    this.updateFooter()
  }

  toggleRow() {
    const selected = this.selectedIds()
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = selected.length === this.rowTargets.length && selected.length > 0
      this.selectAllTarget.indeterminate = selected.length > 0 && selected.length < this.rowTargets.length
    }
    this.updateFooter()
  }

  updateFooter() {
    const count = this.selectedIds().length
    if (this.hasCountTarget) this.countTarget.textContent = count
    if (this.hasFooterTarget) {
      this.footerTarget.classList.toggle("hidden", count === 0)
    }
  }

  selectedIds() {
    return this.rowTargets.filter(cb => cb.checked).map(cb => cb.dataset.id)
  }

  submit(event) {
    event.preventDefault()
    const ids = this.selectedIds()
    if (ids.length === 0) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const button = event.currentTarget
    button.disabled = true
    const originalLabel = button.textContent
    button.textContent = "En cours…"

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ ids: ids, action_type: this.actionTypeValue })
    }).then(r => r.json()).then(data => {
      if (data.ok) {
        // Reload pour refléter les changements (gift_sent_at, KPI, etc.)
        window.location.reload()
      } else {
        alert(`Erreur : ${data.error || "Bulk update échoué"}`)
        button.disabled = false
        button.textContent = originalLabel
      }
    }).catch(err => {
      console.error("[bulk-actions] failed", err)
      alert("Erreur réseau lors du bulk update")
      button.disabled = false
      button.textContent = originalLabel
    })
  }
}
